import * as React from 'react';
export const edenredSvg = React.forwardRef(function edenredSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F0F5F7',
      d: 'M0 .001h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M18.851 15.467c.121-.982.862-1.36 1.813-1.36.183 0 .407.037.563.062.056.009.104.017.137.02l-.218 1.006a1.305 1.305 0 0 0-.46-.09c-.55 0-.701.361-.701.924v2.086h-1.16c-.931 3.714-4.327 6.466-8.348 6.466a8.577 8.577 0 0 1-8.421-6.898 7.029 7.029 0 0 1-.056-.36l.01.043c.004.011.007.025.013.05a.835.835 0 0 0 .153.314v.001c.244.314.635.356.635.356.1.017.205.027.315.027h2.262l.166-1.02H3.511c-.317 0-.483-.18-.483-.563v-.63h1.999l.165-.984H3.028v-1.08h2.39l.159-1.02H2.53A8.583 8.583 0 0 1 10.477 7.5c4.546 0 8.072 3.517 8.371 7.966h.003Zm-1.18 2.648h1.153v-2.371c0-1.133-.829-1.636-1.93-1.636-1.1 0-1.93.502-1.93 1.636v2.371h1.154v-2.086c0-.563.218-.923.776-.923.559 0 .777.36.777.923v2.086Zm-9.848.075c1.41 0 2.263-.84 2.263-2.274h-.001v-3.1H8.93v1.74c-.211-.225-.633-.45-1.206-.45-1.252 0-2.089.819-2.089 2.042 0 1.17.882 2.041 2.187 2.041Zm6.122-1.096c-.295.135-.609.233-.949.233-.535 0-1.153-.248-1.266-.894h2.986c.03-1.41-.694-2.326-2.142-2.326-1.282 0-2.119.856-2.119 1.996 0 1.313.935 2.086 2.263 2.086.4 0 .8-.052 1.13-.187l.097-.908Zm-1.333-2.177c-.498 0-.814.323-.912.75h1.772c-.06-.472-.393-.75-.86-.75Zm-4.735.188c-.634 0-1.034.435-1.034 1.043 0 .6.407 1.05 1.034 1.05.626 0 1.048-.428 1.048-1.05 0-.623-.423-1.043-1.048-1.043Zm15.404-.998c-1.282 0-2.12.856-2.12 1.996 0 1.313.936 2.086 2.263 2.086.4 0 .8-.052 1.131-.187l.096-.908c-.294.135-.608.233-.947.233-.535 0-1.154-.248-1.267-.894h2.987c.028-1.41-.696-2.326-2.143-2.326Zm-.875 1.561c.098-.427.415-.75.912-.75.468 0 .8.277.86.75h-1.772Zm6.44-1.111v-1.74H30v3.099c0 1.433-.852 2.273-2.262 2.273-1.305 0-2.188-.87-2.188-2.041 0-1.223.837-2.041 2.09-2.041.572 0 .994.225 1.206.45Zm-2.09 1.592c0 .6.408 1.05 1.034 1.05.626 0 1.048-.428 1.048-1.05 0-.623-.423-1.043-1.048-1.043-.634 0-1.034.435-1.034 1.043Z',
      fill: '#F72717',
    }),
  );
});
edenredSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var edenred = {
  category: 'brand',
  colorable: false,
  name: 'edenred',
  svg: edenredSvg,
};
